import React from "react";

const JoinTeam = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-12 ">
      {/* Heading */}
            <h1 className="text-3xl sm:text-4xl font-bold text-[#b7b7a1] mb-6">

        Join Our Team
      </h1>

      {/* Intro */}
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        Are you ready to take your career to the next level? Join our dynamic
        team at <strong>Charethri Business Solutions</strong> where innovation
        meets opportunity! We are currently seeking passionate individuals to
        fill the role of{" "}
        <span className="font-semibold">Liaising Officer</span> (Part Time / Full
        Time).
      </p>

      {/* Role description */}
      <p className="text-gray-700 mb-4 leading-relaxed">
        As a Liaison Officer, you will act as a vital bridge between our
        customers and various government departments. Your role involves
        facilitating communication, addressing inquiries, and ensuring that
        customer needs are understood and met by the relevant authorities. You
        will work closely with both clients and government representatives,
        fostering strong relationships to streamline processes and resolve
        issues efficiently.
      </p>

      <p className="text-gray-700 mb-4 leading-relaxed">
        Your expertise in navigating government protocols will enhance customer
        satisfaction and promote effective collaboration across departments.
      </p>

      {/* Benefits */}
      <p className="text-gray-700 mb-4 leading-relaxed">
        In this exciting position, you will have the chance to work alongside
        industry leaders, tackle challenging projects, and make a real impact
        in a collaborative environment. Enjoy competitive salaries, excellent
        benefits, and opportunities for professional growth.
      </p>

      {/* Call to action */}
      <p className="text-gray-800 font-semibold mb-6">
        If you’re driven, creative, and eager to contribute to a
        forward-thinking company, we want to hear from you!
      </p>

      {/* Email Button */}
      <div className="flex justify-center">
        <a
          href="mailto:info@charethribs.com?subject=Application%20for%20Liaising%20Officer&body=Dear%20Hiring%20Team%2C%0A%0AI%20am%20interested%20in%20applying%20for%20the%20Liaising%20Officer%20position.%0A%0AName%3A%0AContact%3A%0AResume%3A%20(Attach%20if%20possible)%0A%0ARegards%2C%0A"
          className="px-6 py-3 bg-[#b7b7a1] text-white rounded-lg shadow-md hover:bg-[#a0a08b] transition"
        >
          Apply Now
        </a>
      </div>
    </div>
  );
};

export default JoinTeam;
